import { ReturnRequestLineItemDto } from "@babackapp/private-api-client/types";

type GetLineItemQuantityAlreadyValidatedByLogisticianParams = {
  lineItem: ReturnRequestLineItemDto;
};

/**
 * For a given line item, returns the quantity that has already been validated by a logistician.
 * To get it, we look at any action that has been done by a logistician on the line item
 * that has the status "ok" and we sum the quantity of all these actions.
 */
export function getLineItemQuantityAlreadyValidatedByLogistician({
  lineItem,
}: GetLineItemQuantityAlreadyValidatedByLogisticianParams) {
  return Math.max(
    0,
    lineItem.logistician_informations.reduce((acc, logisticianInformation) => {
      if (logisticianInformation.status === "ok") {
        return acc + logisticianInformation.quantity;
      }
      return acc;
    }, 0) -
      lineItem.merchant_informations.reduce(
        (acc, merchantInformation) => acc + merchantInformation.quantity,
        0,
      ),
  );
}
